import { config } from '../config';

export function getActiveLicenses() {
  return {
    method: 'GET',
    url: `${config.core.ugUrl}/api/coreui/dashboard/active-licenses`,
  };
}

export function getRewardsAndDistributionHistory() {
  return {
    method: 'GET',
    url: `${config.core.ugUrl}/api/coreui/rewards/distribution-history-report`,
  };
}

export function getTotalRewards() {
  return {
    method: 'GET',
    url: `${config.core.ugUrl}/api/coreui/rewards/total`,
  };
}
